module.exports = __webpack_public_path__ + "static/sundowner1-ad3af6c82afde1cb229c835e44936218.jpg";